module.exports = __webpack_public_path__ + "img/Patent_9.235d54ec.png";